import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import PromoMessage from '../../promo-message';
import DatePicker from '../../date-picker';

class Component extends BaseComponent {
    render({ route }) {
        if (route != 'everyone') {
            return this.renderForYou();
        }

        return this.renderForEveryone();
    }

    renderForYou = () => {
        if (this.props.logged_in && this.props.tcod && this.props.tcod.you) {
            return (
                <daily-tarot-card-mobile>
                    {this.renderTop()}
                    {this.renderTCOD(this.props.tcod.you)}
                </daily-tarot-card-mobile>
            );
        }

        return (
            <daily-tarot-card-mobile>
                {this.renderTop()}
                <a href='#login'>
                    <img
                        src='https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg'
                        alt='Unknown Tarot Card'
                        height='225'
                        width='225'
                    />
                </a>
                <h2>Create Your Profile To Find Out!</h2>
                <p>
                    Looking for your Tarot Card of the Day? Create your profile to receive a Tarot card that's
                    personalized to YOU every day!
                </p>
                <a href='#login' className='button'>CREATE MY PROFILE</a>
                <p>Already a Tarot.com member? <a href='#login'>Login Now</a></p>
            </daily-tarot-card-mobile>
        );
    }

    renderForEveryone = () => {
        if (this.props.tcod && this.props.tcod.everyone) {
            return (
                <daily-tarot-card-mobile>
                    {this.renderTop()}
                    {this.renderTCOD(this.props.tcod.everyone)}
                </daily-tarot-card-mobile>
            );
        }

        return (
            <daily-tarot-card-mobile />
        );
    }

    renderTop = () => {
        return [
            <row className='is-aligned-center'>
                <column className='is-1'>
                    <DatePicker
                        mindate={dayjs().subtract(90, 'day').format('YY-MM-DD')}
                        maxdate={dayjs().add(2, 'day').format('YY-MM-DD')}
                        autosubmit='true'
                        date={dayjs(this.props.date).format('YYYY-MM-DD')}
                        page='tarot-card'
                        url={`${this.props.base_url || '/daily-tarot-card'}/:date`}
                    />
                </column>
                <column className='is-11 has-padding-20-left-mobile'>
                    {this.renderDailyLinks()}
                </column>
            </row>,
            <h1>Tarot Card of the Day</h1>,
        ];
    }

    renderDailyLinks = () => {
        return (
            <div className='daily-links'>
                <a href='#everyone' className={this.props.route == 'everyone' ? 'selected' : ''}>FOR EVERYONE</a>
                <a href='#you' className={this.props.route != 'everyone' ? 'selected' : ''}>FOR YOU</a>
                <a href='/readings-reports/subscription/vip-membership'>VIP Horoscopes</a>
            </div>
        );
    }

    renderTCOD = (tcod) => {
        if (tcod) {
            const img_url = `https://gfx.tarot.com/images/site/decks/${tcod.deck_code}/full_size/${tcod.card_id}.jpg`;
            const placement = this.props.base_url.match(/vip/) ? 'in-product' : 'text';
            const tags = this.props.base_url.match(/vip/) ? 'vip,text,daily' : 'tarot';

            return (
                <div>
                    <p className='has-text-center'>
                        <a
                            href={`/tarot/cards/${tcod.card.canonical_rank}/${tcod.deck_code}`}
                            target='_blank'
                            rel='noopener'
                        >
                            <img src={img_url} alt={tcod.card.name} height='300' />
                        </a>
                    </p>
                    <small>
                        <a href={`/tarot/decks/${tcod.deck_code}`}>
                            {tcod.deck.name}
                        </a> deck {tcod.deck.deck_vendor_copyright}
                    </small>
                    <br />
                    {tcod.interp_body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p>
                                    <b>{dayjs(this.props.date).format('M.D.YY')} {tcod.card.name}: </b>
                                    {p}
                                </p>
                            );
                        }
                        return (<p>{p}</p>);

                    })}
                    <p><PromoMessage placement={placement} tags={tags} /></p>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    tcod: state.tcod,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
});

export default connect(mapStateToProps)(Component);